import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect w="100%" selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView w="100%">
          <MobileScreen>
            <CFLink href="https://goo.gl/maps/R74NaZtSxFbp55d46">
              <CFImage src={mobileMap} w="100%" alt="Yale sushi Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen w="100%">
            <CFLink w="100%" href="https://goo.gl/maps/R74NaZtSxFbp55d46">
              <CFImage
                src={locationMap}
                w="100%"
                alt="Yale sushi Kitchen Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
